import React, { useEffect, useState } from 'react';
import styles from './InputComponents.module.css';

const CalculatedInput = ({ question, allData }) => {
    const [calculatedValue, setCalculatedValue] = useState('');

    useEffect(() => {
        // Calculate BMI if this is a BMI field
        if (question.id === 'bmi') {
            const height = parseFloat(allData.height);
            const weight = parseFloat(allData.weight);

            if (height && weight && height > 0) {
                const heightInMeters = height / 100;
                const bmi = (weight / (heightInMeters * heightInMeters)).toFixed(2);
                setCalculatedValue(bmi);
            } else {
                setCalculatedValue('');
            }
        }

        // Calculate FIB-4 Score if this is a FIB-4 field
        if (question.id === 'fib4_score') {
            const age = parseFloat(allData.age);
            const ast = parseFloat(allData.ast);
            const alt = parseFloat(allData.alt);
            const plateletCount = parseFloat(allData.platelet_count);

            if (age && ast && alt && plateletCount && alt > 0 && plateletCount > 0) {
                const fib4 = ((age * ast) / (plateletCount * Math.sqrt(alt))).toFixed(2);
                setCalculatedValue(fib4);
            } else {
                setCalculatedValue('');
            }
        }
    }, [allData, question.id]);

    return (
        <div className={styles.questionWrapper}>
            <label className={styles.questionLabel}>
                {question.text}
                {question.annotation && (
                    <span className={styles.annotation}> ({question.annotation})</span>
                )}
            </label>
            <input
                type="text"
                value={calculatedValue}
                disabled
                className={`${styles.input} ${styles.calculatedInput}`}
                placeholder="Auto-calculated"
            />
            <small className={styles.helpText}>This value is automatically calculated</small>
        </div>
    );
};

export default CalculatedInput;
